import http from 'api/httpClient';

export interface UARDivision {
  division_ou_code: string;
  division_name: string;
  uar: number;
}

export interface UARDivisionsResponse {
  divisions: UARDivision[];
  unallocated_uar: number;
  total_uar: number;
}

export interface UARAgeingRow {
  customer_name: string;
  customer_code: string;
  collection_responsibility: string[];
  uar: number;
  mr_count: number;
  bucket_1_30: number;
  bucket_31_60: number;
  bucket_61_90: number;
  bucket_91_120: number;
  bucket_121_180: number;
  bucket_over_180: number;
}

export interface UARAgeingResponse {
  rows: UARAgeingRow[];
  page: number;
  page_size: number;
  total_items: number;
  total_pages: number;
  has_previous: boolean;
  has_next: boolean;
}

export interface UARAgeingRequest extends Record<string, unknown> {
  year: string;
  month: number;
  day: number;   
  division?: string;
  ecode?: string;
  collection_resp?: 'allocated' | 'unallocated';
  search?: string;
}

export interface UARMrDetailRow {
  reference_no: string;
  utr_no: string;
  utr_date: string;
  utr_amt: number;
  mr_date: string;
  overdue_days: number;
  transaction_amt: number;
  mr_amount: number;
}

export interface UARMrDetailsResponse {
  rows: UARMrDetailRow[];
  page: number;
  page_size: number;
  total_items: number;
  total_pages: number;
}

export interface UARMrDetailsRequest extends Record<string, unknown> {
  year: string;
  month: number;
  day: number;   
  customer_code: string;
  page?: number;
  per_page?: number;
  sort_by?: 'reference_no' | 'utr_no' | 'utr_date' | 'utr_amt' | 'mr_date' | 'overdue_days' | 'transaction_amt' | 'mr_amount';
  sort_order?: 'asc' | 'desc';
}


export async function fetchUarDivisions(year: string, month: number, day: number): Promise<UARDivisionsResponse> {
  const params = new URLSearchParams({ year, month: String(month), day: String(day)});
  return http.get(`/api/v1/uar/divisions?${params.toString()}`)
}


export async function fetchUarAgeing(
  payload: UARAgeingRequest
): Promise<UARAgeingResponse> {
  return http.post('/api/v1/uar/ageing', payload);
}

export async function fetchUarMrDetails(payload: UARMrDetailsRequest): Promise<UARMrDetailsResponse> {
  return http.post('/api/v1/uar/mr-details', payload);
}

export async function downloadUarMrDetails(payload: UARMrDetailsRequest): Promise<Blob> {
  return http.post('/api/v1/uar/download-mr-details', payload, { responseType: 'blob' });
}